module.exports = __webpack_public_path__ + "img/5.a018be74.jpg";